export default __webpack_public_path__ + "static/media/linked-tree.28b94d01.svg";